"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const logger_1 = require("../../../service-lib/src/lib/logger");
let AppService = class AppService {
    constructor() {
        this.logger = (0, logger_1.createLogger)();
    }
    getData() {
        // Log when the method is invoked
        this.logger.log({
            level: 'info',
            message: 'getData method invoked',
            context: 'getDataService',
            additionalInfo: { method: 'getData' },
        });
        const response = { message: 'Auth Service API running successfully..' };
        // Log the response being returned
        this.logger.log({
            level: 'info',
            message: 'Successfully retrieved data',
            context: 'getDataService',
            additionalInfo: { method: 'getData', response },
        });
        return response;
    }
};
exports.AppService = AppService;
exports.AppService = AppService = tslib_1.__decorate([
    (0, common_1.Injectable)()
], AppService);
